import { useEffect, useState } from "react";
import Dialog from "./Dialog"

const TYPES = {
	OPTIONAL: 1,
	REQUIRED: 2
}

const QuestionDialog = (props) => {
	const { isOpen, allQuestions, processReducerState, setState, handleSuccess } = props;
	const [currentQuestion, setQuestion] = useState(null);

	const onConfirm = async () => {
		await processReducerState("QUESTION_ACCEPT", { currentQuestion }, true);
		nextQuestion();
	}

	const onCancel = async () => {
		await processReducerState("QUESTION_DECLINE", { currentQuestion }, false);
		if (currentQuestion.type === TYPES.OPTIONAL) {
			nextQuestion();
		} else {
			resetQuestions();
		}
	}

	const onClose = async () => {
		resetQuestions();
	}

	const nextQuestion = () => {
		if (allQuestions?.length > 1) {
			const newQuestions = allQuestions.slice(1);
			setState(prev => ({ ...prev, questions: { ...prev.questions, list: newQuestions } }));
			setQuestion(newQuestions[0])
		} else {
			handleSuccess();
		}
	}

	const resetQuestions = () => {
		setState(prev => ({ ...prev, questions: null }));
	}

	useEffect(() => {
		if (isOpen) {
			setQuestion(allQuestions[0]);
		}
	}, [isOpen])

	return (
		<Dialog
			title="Potvrdenie"
			onClose={onClose}
			onConfirm={onConfirm}
			onCancel={onCancel}
			isOpen={isOpen}
			cancelText={"Nie"}
			confirmText={"Áno"}
		>
			<div style={{ padding: 20 }}>
				{currentQuestion?.txt}
			</div>
		</Dialog>
	)
}
export default QuestionDialog